import ModelInterface from 'src/models/ModelInterface'
import {RawUser} from '@/types/entity/RawUser'
import store from '@/store/index'

class User extends ModelInterface<RawUser> {

  constructor (data: RawUser) {
    super(data)
  }

  public getId () {
    return this.data.lsn_id
  }

  public getFirstName () {
    return this.data.first_name || '';
  }

  public getLastName () {
    return this.data.last_name || '';
  }

  public getMiddleName () {
    return this.data.middle_name || '';
  }

  public getUpic () {
    return '';
  }

  public getMsgr () {
    return this.data.msgr || {};
  }

  public getCodes () {
    return this.data.codes || {}
  }

  public getNewsfeed () {
    return this.data.newsfeed
  }

  public checkRole (role: string): boolean {
    return true;
  }

  /**
   * User full name
   * @returns {String}
   */
  public getFullName () {
    let fullName = ''
    fullName += this.getLastName() ? this.getLastName() + ' ' : ''
    fullName += this.getFirstName() ? this.getFirstName() + ' ' : ''
    fullName += this.getMiddleName() ? this.getMiddleName() + ' ' : ''
    return fullName;
  }

}

export default User
